export default __webpack_public_path__ + "img/Litsea_cubeba.cf806797.jpg";